/* eslint-disable */
import _ from 'lodash';
import Wix from '../sdk/WixSdkWrapper';
import { baseUtils } from './baseUtils';
import { getProGalleryStylesImp } from './proGalleryStyleBuilder';
import window from '../sdk/windowWrapper';

var StyleParamsHelper = /*#__PURE__*/function () {
  function StyleParamsHelper() {}

  var _proto = StyleParamsHelper.prototype;

  _proto.shouldProcessStyles = function shouldProcessStyles(styles) {
    if (Object.keys(styles).length === 1 && Object.keys(styles)[0] === 'previewHover') {
      //make sure it is not the preview Hover param passed manually (previewHover)
      return false;
    }

    return true;
  };

  _proto.getStylesFromWix = function getStylesFromWix() {
    var wixStyles = {};
    var gotStyleParams = !(baseUtils.isInWix() && !baseUtils.isDemo()); // if in Wix wait for real (not default) style params

    if (baseUtils.isInWix() && Wix && Wix.Styles && Wix.Styles.getStyleParams) {
      var sp = Wix.Styles.getStyleParams();
      baseUtils.isVerbose() && console.log('Got raw styles from Wix', sp);

      if (typeof sp === 'object' && sp !== null) {
        _.merge(wixStyles, sp.booleans, sp.numbers, sp.colors, sp.fonts);

        if (this.shouldProcessStyles(wixStyles)) {
          gotStyleParams = true;
        } else {
          return wixStyles; //this will be merged with the current styles
        }
      }
    }

    if (_.isObject(window.galleryStyle)) {
      _.merge(wixStyles, window.galleryStyle);
    }

    if (baseUtils.parseGetParam('galleryStyle')) {
      var galleryStyle = baseUtils.parseGetParam('galleryStyle');

      if (/^[\],:{}\s]*$/.test(galleryStyle.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
        //the json is ok
        _.merge(wixStyles, JSON.parse(decodeURIComponent(galleryStyle)));
      }
    }

    var finalStyles = getProGalleryStylesImp(wixStyles, gotStyleParams, {
      isMobile: baseUtils.isMobile(),
      isStoreGallery: baseUtils.isStoreGallery(),
      isOnBoarding: baseUtils.isOnBoarding()
    });

    if (baseUtils.isVerbose()) {
      console.log('Got styles from Wix', finalStyles);
    }

    return finalStyles;
  };

  return StyleParamsHelper;
}();

export default new StyleParamsHelper();